import {Component, inject, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router, RouterModule} from '@angular/router';
import {DropdownComponent} from '../../../components/ui/dropdown/dropdown.component';
import {DropdownItemTwoComponent} from '../../../components/ui/dropdown/dropdown-item/dropdown-item-router.component';
import {LogoutService} from '../../../services/logout.service';
import {SnackbarService} from '@shared/services/snackbar.service';
import {AuthenticationService} from '@core/auth/authentication.service';
import {AvatarUser} from '../../../components/ui/avatar-user/avatar-user';
import {PerfilService} from '../../../../app/home/perfil/perfil.service';
import {UserPerfil} from '../../../../app/home/perfil/perfil.interface';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {ErrorService} from '../../../services/error.service';

@Component({
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  imports: [
    CommonModule,
    RouterModule,
    DropdownComponent,
    DropdownItemTwoComponent,
    DropdownComponent,
    DropdownItemTwoComponent,
    AvatarUser,
    MatProgressSpinner
  ]
})
export class UserDropdownComponent implements OnInit {
  private logoutService = inject(LogoutService);
  private snackbarService = inject(SnackbarService);
  private errorService = inject(ErrorService);
  private authenticationService = inject(AuthenticationService);
  private perfilService = inject(PerfilService);
  private router = inject(Router);

  isOpen = false;
  loading = false;
  loadingUser = false;
  user!: UserPerfil;

  ngOnInit(): void {
    this.getPerfil();
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  signOut(): void {
    this.loading = true;
    this.logoutService.logout().subscribe({
      next: (response) => {
        this.snackbarService.showSnackBar(response.message);
        this.authenticationService.deleteSession();
        this.router.navigate(['/login'], {replaceUrl: true});
      },
      error: (error) => {
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.loading = false;
    });
  }

  getPerfil(): void {
    this.loadingUser = true;
    this.perfilService.show().subscribe({
      next: (response) => {
        if (response.status) {
          this.user = response.data;
        }
      },
      error: (error) => {
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.loadingUser = false;
    });
  }
}
